import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { DataGrid, getGridStringOperators, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState, useCallback, useContext } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import { ThemeContext } from '../../context/ThemeContext';
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import EditIcon from '@mui/icons-material/Edit';
import DeleteImpactStories from "./delete-impact-stories";
import { impactStoriesApi } from "../../store/impactStory/impactStoriesList";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import PermissionGate from "../../components/PermissionGate";

export default function ManageImpact() {
  const impactStories = useSelector((state) => state?.impactStories);
  const { result, order_category, loading, total } = impactStories;
  const [isDownload, setIsDownload] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [podcastBulk, setPodcastBulk] = useState(false);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const columns = [
    {
      field: "story_title",
      headerName: "Story title",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },
    {
      field: "teacher_name",
      headerName: "Teacher name",
      filterable: false,
      sortable: false,
      width: 200,
    },
    {
      field: "admin_approved",
      headerName: "Status",
      filterable: false,
      sortable: false,
      width: 200,
      disableExport: true,
      renderCell: (row) => (
        <>
          {row.row.admin_approved != null ? row.row.admin_approved ? "Approved" : "Rejected" : "Pending"}
        </>
      ),
    },
    {
      field: "story_image",
      headerName: "Story Image",
      filterable: false,
      sortable: false,
      width: 250,
      renderCell: (params) => (
        <Box sx={{ py: 1 }}><img width={200} height={100} src={params.row.story_image} alt='story image' /></Box>)
    },
    {
      field: "category",
      headerName: "Category",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "update_podcast",
      headerName: "Update Story",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="impact_story" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => navigate(`/impact-story-details/${row.id}`)}
            >
              Edit
            </Button>
          </PermissionGate>
        </>
      ),
    },

  ];

  const addToCartHandler = async () => {
    navigate("/add-podcast");
  };



  useEffect(() => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || (quickFilterValues && "story_title") || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(impactStoriesApi(query));
  }, [dispatch, queryOptions, paginationModel]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>

        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Manage Impact Stories</Typography>
        </Stack>
        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
                    height: 500 
                }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "impactstoriesManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, permissionModule: "impact_story", apiUrl: apiRoutes.impactStoryList })),
            }}
            slotProps={{
loadingOverlay: {
      variant: 'linear-progress',
      noRowsVariant: 'linear-progress',
    },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>
      </Body>

      <DeleteImpactStories
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        id={deleteId}
      />
      <BackdropUI open={isDownload} />
    </>
  );
}
